<template v-cloak>
    <NuxtLayout name="main" :class="i18n.locale.value === 'en' ? 'en' : 'zh'">
        <section class="header-container">
            <div class="text-[56px] text-white font-bold container">{{ $t("PrivacyPolicy") }}</div>
        </section>

        <section class="flex items-center h-[64px] bg-uicolor5">
            <div class="container">{{ $t("Home.Name") }} > {{ $t("AboutUs") }} > {{ $t("PrivacyPolicy") }}</div>
        </section>

        <section class="content-container container">
            <div class="text-[44px] leading-[76px] text-emphas font-bold">{{ $t("PrivacyI18n.Title") }}</div>

            <div class="flex mt-[24px]">
                <div>{{ $t("PrivacyI18n.LastUpdated") }}</div>
                <div class="ml-[40px]">{{ $t("PrivacyI18n.EffectiveDate") }}</div>
            </div>

            <div class="paragraph">
                <p v-html="$t('PrivacyI18n.Descript1')"></p>
            </div>

            <div class="paragraph mt-[54px]">
                <h2 v-html="$t('PrivacyI18n.Section1')"></h2>
                <p v-html="$t('PrivacyI18n.Descript2')"></p>
                <ol>
                    <li v-html="$t('PrivacyI18n.Descript3')"></li>
                    <li v-html="$t('PrivacyI18n.Descript4')"></li>
                    <li v-html="$t('PrivacyI18n.Descript5')"></li>
                    <li v-html="$t('PrivacyI18n.Descript6')"></li>
                </ol>
                <p v-html="$t('PrivacyI18n.Descript7')"></p>
            </div>

            <div class="paragraph">
                <h2 v-html="$t('PrivacyI18n.Section2')"></h2>
                <ol>
                    <li v-html="$t('PrivacyI18n.Descript8')"></li>
                    <li v-html="$t('PrivacyI18n.Descript9')"></li>
                    <div class="pl-[24px]">
                        <div v-html="$t('PrivacyI18n.Descript10')"></div>
                        <div v-html="$t('PrivacyI18n.Descript11')"></div>
                        <div v-html="$t('PrivacyI18n.Descript12')"></div>
                        <div v-html="$t('PrivacyI18n.Descript13')"></div>
                    </div>
                    <li v-html="$t('PrivacyI18n.Descript14')"></li>
                    <li v-html="$t('PrivacyI18n.Descript15')"></li>
                </ol>
                <p v-html="$t('PrivacyI18n.Descript16')"></p>
            </div>

            <div class="paragraph">
                <h2 v-html="$t('PrivacyI18n.Section3')"></h2>
                <p v-html="$t('PrivacyI18n.Descript17')"></p>
                <ol>
                    <li v-html="$t('PrivacyI18n.Descript18')"></li>
                    <li v-html="$t('PrivacyI18n.Descript19')"></li>
                    <li v-html="$t('PrivacyI18n.Descript20')"></li>
                </ol>
                <p v-html="$t('PrivacyI18n.Descript21')"></p>
            </div>
            <div class="paragraph">
                <h2 v-html="$t('PrivacyI18n.Section4')"></h2>
                <p v-html="$t('PrivacyI18n.Descript22')"></p>
                <ol>
                    <li v-html="$t('PrivacyI18n.Descript23')"></li>
                    <li v-html="$t('PrivacyI18n.Descript24')"></li>
                    <li v-html="$t('PrivacyI18n.Descript25')"></li>
                </ol>
            </div>
            <div class="paragraph">
                <h2 v-html="$t('PrivacyI18n.Section5')"></h2>
                <p v-html="$t('PrivacyI18n.Descript26')"></p>
                <ol>
                    <li v-html="$t('PrivacyI18n.Descript27')"></li>
                    <li v-html="$t('PrivacyI18n.Descript28')"></li>
                    <li v-html="$t('PrivacyI18n.Descript29')"></li>
                    <li v-html="$t('PrivacyI18n.Descript30')"></li>
                    <li v-html="$t('PrivacyI18n.Descript31')"></li>
                    <li v-html="$t('PrivacyI18n.Descript32')"></li>
                </ol>
                <p v-html="$t('PrivacyI18n.Descript33')"></p>
            </div>
            <div class="paragraph">
                <h2 v-html="$t('PrivacyI18n.Section6')"></h2>
                <div>
                    <p class="indent" v-html="$t('PrivacyI18n.Descript34')"></p>
                    <p class="indent mt-[4px]" v-html="$t('PrivacyI18n.Descript35')"></p>
                </div>
            </div>
            <div class="paragraph">
                <h2 v-html="$t('PrivacyI18n.Section7')"></h2>
                <p v-html="$t('PrivacyI18n.Descript36')"></p>
            </div>
            <div class="paragraph">
                <h2 v-html="$t('PrivacyI18n.Section8')"></h2>
                <p v-html="$t('PrivacyI18n.Descript37')"></p>
                <div class="mt-[32px] font-bold text-emphas">
                    <p v-html="$t('PrivacyI18n.Email')"></p>
                    <p class="mt-[4px]" v-html="$t('PrivacyI18n.Address')"></p>
                </div>
                <p v-html="$t('PrivacyI18n.Descript38')"></p>
            </div>
        </section>
    </NuxtLayout>
</template>

<script lang="ts" setup>
const i18n = useI18n();
</script>

<style lang="less" scoped>
.header-container {
    display: flex;
    align-items: center;
    width: 100%;
    height: 300px;
    background: url("@/assets/images/privacy/header-cover.webp") center no-repeat;
    background-size: cover;
}

.content-container {
    margin: 64px auto 0;

    .paragraph {
        margin: 64px 0 0;
        > * {
            margin-top: 32px;
        }
    }

    h2 {
        position: relative;
        display: flex;
        align-items: center;
        color: var(--uicolor-font-1);
        padding-left: 16px;
        font-size: 20px;
        line-height: 36px;

        &::before {
            position: absolute;
            top: 0;
            left: 0;
            content: "";
            width: 16px;
            height: 34px;
            background: url("@/assets/images/privacy/icon-item-443c805b-41d4-4b15-b6d9-3cf7d5d60769.webp") center no-repeat;
            background-size: contain;
        }
    }
    ol {
        margin: 0;
        padding: 0;
        list-style: none;
        counter-reset: level1;
        > li {
            padding-inline-start: 24px;
            text-indent: -24px;
            &:not(:first-child) {
                margin-top: 16px;
            }
            &::before {
                font-weight: bold;
                color: var(--uicolor-font-1);
                counter-increment: level1;
            }
        }
    }
}

// 中文格式
.zh {
    ol {
        > li::before {
            content: counter(level1) "、";
        }
    }
    .indent {
        padding-left: 36px;
        text-indent: -36px;
    }
}

// 英文格式
.en {
    h2 {
        padding-left: 24px;
    }
    ol {
        > li::before {
            padding-right: 8px;
            content: counter(level1) ". ";
        }
    }
    .indent {
        padding-left: 18px;
        text-indent: -18px;
    }
}
</style>
